import React, { Component } from 'react';
import { FormGroup, FormControl, ControlLabel, Col } from 'react-bootstrap';
import { getDayOptions, getMonthOptions, getYearOptions } from './../services/dateServices'
import Api from './../../../Global/Modules/Api'

class UwGegevens extends Component {
    constructor(props) {
        super(props)
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(event) {
        const target = event.target
        const name = target.name
        const value = target.value
        this.props.onChange(name, value)
        //this.setState({ [name]: value })
    }

    render() {
        const errors = this.props.errors
        const data = this.props.data

        return (
            <div>
                <h5>Uw gegevens</h5>
                <FormGroup controlId="Account">
                    <Col componentClass={ControlLabel} sm={4}>
                        Geslacht
                </Col>
                    <Col sm={6}>
                        <FormControl componentClass="select" name="gender" value={data.gender} placeholder="" onChange={this.handleChange}>
                            <option value="0">Man</option>
                            <option value="1">Vrouw</option>
                        </FormControl>
                    </Col>
                </FormGroup>

                <FormGroup controlId="AccountTitleBeforeName">
                    <Col componentClass={ControlLabel} sm={4}>
                        Titel voor achternaam
                </Col>
                    <Col sm={6}>
                        <FormControl value={data.titlePrefix} type="text" name="titlePrefix" onChange={this.handleChange} />
                        {Api.showError(errors, "titlePrefix")}
                    </Col>
                </FormGroup>
                {/*
                    TODO: Voorletters: seperate all letters with dot. so if you fill in abc we convert to 'A.B.C.' in capitalised letters
                */}
                <FormGroup controlId="AccountVoorletters">
                    <Col componentClass={ControlLabel} sm={4}>
                        Voorletters
                </Col>
                    <Col sm={6}>
                        <FormControl value={data.initials} type="text" name="initials" onChange={this.handleChange} />
                        {Api.showError(errors, "initials")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="AccountVoornaam">
                    <Col componentClass={ControlLabel} sm={4}>
                        Voornaam *
                    </Col>
                    <Col sm={6}>
                        <FormControl value={data.firstName} type="text" name="firstName" onChange={this.handleChange} required />
                        {Api.showError(errors, "firstName")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="AccountTussenvoegsel">
                    <Col componentClass={ControlLabel} sm={4}>
                        Tussenvoegsel
                    </Col>
                    <Col sm={6}>
                        <FormControl value={data.middleName} type="text" name="middleName" onChange={this.handleChange} />
                        {Api.showError(errors, "middleName")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="AccountVoornaam">
                    <Col componentClass={ControlLabel} sm={4}>
                        Achternaam *
                </Col>
                    <Col sm={6}>
                        <FormControl value={data.lastName} type="text" name="lastName" required onChange={this.handleChange} />
                        {Api.showError(errors, "lastName")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="AccountTitleAfterName">
                    <Col componentClass={ControlLabel} sm={4}>
                        Titel na achternaam
                    </Col>
                    <Col sm={6}>
                        <FormControl value={data.title} type="text" name="title" onChange={this.handleChange} />
                        {Api.showError(errors, "title")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="AccountGeboorteDatum">
                    <Col componentClass={ControlLabel} sm={4}>
                        Geboorte datum
                    </Col>
                    <Col sm={6}>
                        <FormControl value={data.day} componentClass="select" placeholder="" name="day" onChange={this.handleChange} required>
                            <option value="">dag</option>
                            {getDayOptions}
                        </FormControl>
                        {Api.showError(errors, "birthdate")}

                        <FormControl value={data.month} componentClass="select" placeholder="" name="month" onChange={this.handleChange} required>
                            <option value="">maand</option>
                            {getMonthOptions}
                        </FormControl>

                        <FormControl value={data.year} componentClass="select" placeholder="" name="year" onChange={this.handleChange} required >
                            <option value="">jaar</option>
                            {getYearOptions(2025, 1929)}
                        </FormControl>
                    </Col>
                </FormGroup>

            </div>
        );
    }
}

export default UwGegevens;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Account/UwGegevens.js